import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { getFormIsDirty } from "../selectors";
import { SOURCE_LEAVE } from "../Subscription";
import useFormActions from "../useFormActions";
import useFormState from "../useFormState";

export default function useDirtyForm(onLeavePage) {
	const dirty = useSelector(getFormIsDirty);
	const { onSubmitForm } = useFormActions();
	const { redirect } = useFormState();

	const handleOnbeforeunload = useCallback((event) => {
		onLeavePage();
		onSubmitForm(SOURCE_LEAVE);
		event.returnValue = "Changes you made may not be saved.";
	}, []);

	useEffect(() => {
		let callbackMounted = false;
		if (dirty) {
			window.addEventListener("beforeunload", handleOnbeforeunload);
			callbackMounted = true;
		}

		if (redirect) {
			window.location.href = "/";
		}

		return () => {
			if (callbackMounted) {
				window.removeEventListener(
					"beforeunload",
					handleOnbeforeunload,
				);
			}
		};
	}, [dirty, redirect]);
}
